import ToastContainers from "./Utils/ToastContainer";
import PageNotFound404 from "./Errors/PageNotFound404";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Base from "./Pages/Base";
import './App.css';
import Home from "./Pages/Home";
import AboutUs from "./Pages/AboutUs";
import Services from "./Pages/Services";
import DynamicServiceDetail from "./Pages/Services-Details/DynamicServiceDetail";
import Contact from "./Pages/Contact";
import AdminDashboard from "./Pages/Admin/AdminDashboard";
import CategoryManagement from "./Pages/Admin/CategoryManagement";
import DataManagement from "./Pages/Admin/DataManagement";
import AdminLogin from "./Pages/Admin/Login";


function App() {
  return (
    <>
      <BrowserRouter>

        {/* ToastContainer */}
        <ToastContainers />

        {/* Routes */}
        <Routes>

          {/* Web Routes */}
          <Route path='/' element={<Base><Home title={"Home"}/></Base>} />
          <Route path='/about-us' element={<Base><AboutUs title={"About us"}/></Base>} />
          <Route path='/services-overview' element={<Base><Services title={"Services Overview"}/></Base>} />
          <Route path='/contact' element={<Base><Contact title={"contact us"}/></Base>} />

          {/* ========================== Dynamic Service Detail Route ============================ */}
          <Route path='/service/:id' element={<Base><DynamicServiceDetail/></Base>} />

          {/* ========================== Admin Routes ============================ */}
          <Route path='/admin/login' element={<AdminLogin />} />
          <Route path='/admin' element={<AdminDashboard />}>
            <Route index element={<CategoryManagement />} />
            <Route path='categories' element={<CategoryManagement />} />
            <Route path='data' element={<DataManagement />} />
          </Route>

          <Route path='*' element={<PageNotFound404 />} />

        </Routes>

      </BrowserRouter>
    </>
  );
}

export default App;
